// Styles
import { iconsToUse } from '../../../common/styles/themes';
import * as variables from '../../../common/styles/variables';
import { Icon } from '../../../common/components';
import { Link, useHistory } from 'react-router-dom';

import { HealthItemWrapper } from './HealthItem.styles';
import GreenTick from '../../icons/GreenTick';
import Exclamatory from '../../icons/Exclamatory';

type HealthItemProps = {
  text: string;
  route: string;
  visible: boolean;
  status: 'loading' | 'healthy' | 'notHealthy';
  response: any;
  onMoreInfoClick: any;
  customers: Array<any>;
};

const defaultProps = {
  text: '',
  route: '',
  status: '',
  visible: false,
  response: null,
  onMoreInfoClick: null,
  customers: [],
};

export const HealthItem = (props: HealthItemProps) => {
  const history = useHistory();

  const onMoreInfoClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    props.onMoreInfoClick();
  };

  return (
    <>
      {props.visible && (
        <HealthItemWrapper
          className={`${props.status === 'notHealthy' ? 'notHealthy' : ''} ${
            props.status === 'healthy' ? 'healthy' : ''
          }`}
        >
          <div className='p-0 ml-1 mt-2 descCol mr-auto'>
            {props.status === 'notHealthy' && <Icon size={'32px'} icon={Exclamatory} />}
            {props.status === 'healthy' && <Icon size={'32px'} icon={GreenTick} />}
            <span className='pl-0'>&nbsp;{props.text}</span>
          </div>
          <div className='pl-2 pr-4 mt-2 moreInfoCol'>
            &nbsp;
            {props.route && (
              <Link className='moreInfo' to={'/'} onClick={onMoreInfoClick}>
                More info
              </Link>
            )}
          </div>
        </HealthItemWrapper>
      )}
    </>
  );
};

HealthItem.defaultProps = defaultProps;
